import { IDeleteContratoInformacoesUseCase } from "../../../presentation/useCases/delete/delete_contrato_informacoes_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteContratoInformacoesUseCase

export class DeleteContratoInformacoesUseCase implements IDeleteContratoInformacoesUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteContratoInformacoes(IdContratoInformacoes: number): Promise<void> {
    await this.repository.deleteContratoInformacoes(IdContratoInformacoes);
  }
}
